module.exports = __webpack_public_path__ + "img/FolderNotchOpen.508304e0.svg";